import React, { lazy } from 'react';
import { SparklesIcon, ZapIcon, ShieldCheckIcon } from 'lucide-react';
const CART_URL = 'https://fbwqku-s9.myshopify.com/cart/52013268271396:1';
const images = [{
  src: 'https://cdn.shopify.com/s/files/1/0645/3598/6275/files/DOC-20251216-WA0077..jpg?v=1771900369',
  alt: 'Tableta aromática 1'
}, {
  src: 'https://cdn.shopify.com/s/files/1/0645/3598/6275/files/PinDown.io__MY_FLAME_RU_1771900257.jpg?v=1771900369',
  alt: 'Tableta aromática 2'
}, {
  src: 'https://cdn.shopify.com/s/files/1/0645/3598/6275/files/PinDown.io__archain_ula_1771900094.jpg?v=1771900369',
  alt: 'Tableta aromática 3'
}, {
  src: 'https://cdn.shopify.com/s/files/1/0645/3598/6275/files/PinDown.io__thewarmside_cl_1771899962.jpg?v=1771900369',
  alt: 'Tableta aromática 4'
}, {
  src: 'https://cdn.shopify.com/s/files/1/0645/3598/6275/files/PinDown.io__avohandmade_1771900004.jpg?v=1771900369',
  alt: 'Tableta aromática 5'
}, {
  src: 'https://cdn.shopify.com/s/files/1/0645/3598/6275/files/PinDown.io__mariadelcisnesa_1771900053.jpg?v=1771900369',
  alt: 'Tableta aromática 6'
}, {
  src: 'https://cdn.shopify.com/s/files/1/0645/3598/6275/files/PinDown.io__jovisoycandle_1771900123.jpg?v=1771900369',
  alt: 'Tableta aromática 7'
}, {
  src: 'https://cdn.shopify.com/s/files/1/0645/3598/6275/files/PinDown.io__brownlivingindia_1771900154.jpg?v=1771900369',
  alt: 'Tableta aromática 8'
}];
export function NewHeroSection() {
  return <section className="relative bg-gradient-to-b from-white to-[#F8F8FA] py-20 md:py-32 px-4 overflow-hidden" data-id="element-161">
      {/* Subtle background decoration */}
      <div className="absolute inset-0 opacity-5 pointer-events-none" data-id="element-162">
        <div className="absolute top-20 left-10 w-96 h-96 bg-[#FF4DB8] rounded-full blur-3xl" data-id="element-163"></div>
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-[#FF6EC7] rounded-full blur-3xl" data-id="element-164"></div>
      </div>

      <div className="container mx-auto max-w-6xl relative z-10" data-id="element-165">
        {/* Trust badges */}
        <div className="flex flex-wrap items-center justify-center gap-4 md:gap-6 mb-12" data-id="element-166">
          <div className="flex items-center gap-2 px-4 py-2 bg-white/80 backdrop-blur-sm rounded-full border border-white/20 shadow-sm" data-id="element-167">
            <ZapIcon className="w-4 h-4 text-[#FF4DB8]" aria-hidden="true" data-id="element-168" />
            <span className="text-sm font-medium text-[#6B6B6B]" data-id="element-169">
              Acceso inmediato
            </span>
          </div>
          <div className="flex items-center gap-2 px-4 py-2 bg-white/80 backdrop-blur-sm rounded-full border border-white/20 shadow-sm" data-id="element-170">
            <ShieldCheckIcon className="w-4 h-4 text-[#FF4DB8]" aria-hidden="true" data-id="element-171" />
            <span className="text-sm font-medium text-[#6B6B6B]" data-id="element-172">
              Garantía 72hs
            </span>
          </div>
          <div className="flex items-center gap-2 px-4 py-2 bg-white/80 backdrop-blur-sm rounded-full border border-white/20 shadow-sm" data-id="element-173">
            <SparklesIcon className="w-4 h-4 text-[#FF4DB8]" aria-hidden="true" data-id="element-174" />
            <span className="text-sm font-medium text-[#6B6B6B]" data-id="element-175">
              Sin experiencia
            </span>
          </div>
        </div>

        {/* Main content */}
        <div className="text-center mb-16" data-id="element-176">
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-extrabold text-gray-900 mb-6 leading-tight" data-id="element-177">
            Creá tabletas aromáticas
            <br data-id="element-178" />
            <span className="bg-gradient-to-r from-[#FF4DB8] to-[#FF6EC7] bg-clip-text text-transparent" data-id="element-179">
              que se venden solas
            </span>
          </h1>
          <p className="text-xl md:text-2xl text-[#6B6B6B] mb-10 max-w-3xl mx-auto font-medium" data-id="element-180">
            En menos de 24 horas, sin experiencia y listas para generar ingresos
          </p>

          {/* CTA Button */}
          <a href={CART_URL} className="inline-block px-10 py-5 bg-gradient-to-r from-[#FF4DB8] to-[#FF6EC7] hover:from-[#FF6EC7] hover:to-[#FF4DB8] text-white font-bold text-lg rounded-2xl shadow-lg shadow-pink-500/20 transition-all duration-300 hover:shadow-xl hover:shadow-pink-500/30 hover:scale-105" data-id="element-181">
            Acceder ahora
          </a>
        </div>

        {/* Marquee carousel */}
        <div className="relative overflow-hidden py-2" style={{
        width: 'min(1100px, 92vw)',
        margin: '0 auto'
      }} aria-label="Carrusel de imágenes" onMouseEnter={e => {
        const track = e.currentTarget.querySelector<HTMLElement>('.marquee-track');
        if (track) track.style.animationPlayState = 'paused';
      }} onMouseLeave={e => {
        const track = e.currentTarget.querySelector<HTMLElement>('.marquee-track');
        if (track) track.style.animationPlayState = 'running';
      }} data-id="element-182">
          {/* Left fade */}
          <div className="absolute top-0 bottom-0 left-0 z-10 pointer-events-none" style={{
          width: 70,
          background: 'linear-gradient(90deg, rgba(248,248,250,1), rgba(248,248,250,0))'
        }} data-id="element-183" />

          {/* Track */}
          <div className="marquee-track flex" style={{
          gap: 14,
          width: 'max-content',
          animation: 'luxScroll 28s linear infinite',
          willChange: 'transform'
        }} data-id="element-184">
            {/* Group A */}
            <div className="flex" style={{
            gap: 14,
            paddingRight: 14
          }} data-id="element-185">
              {images.map((img, i) => <div key={`a-${i}`} className="flex-none overflow-hidden bg-gray-100" style={{
              width: 220,
              borderRadius: 18,
              boxShadow: '0 16px 40px rgba(0,0,0,.10)'
            }} data-id="element-186">
                  <img src={img.src} alt={img.alt} loading={i === 0 ? 'eager' : 'lazy'} className="w-full block transition-transform duration-500 ease-in-out hover:scale-105" style={{
                aspectRatio: '4/5',
                objectFit: 'cover',
                transform: 'scale(1.02)'
              }} data-id="element-187" />
                </div>)}
            </div>

            {/* Group B (duplicate for infinite loop) */}
            <div className="flex" aria-hidden="true" style={{
            gap: 14,
            paddingRight: 14
          }} data-id="element-188">
              {images.map((img, i) => <div key={`b-${i}`} className="flex-none overflow-hidden bg-gray-100" style={{
              width: 220,
              borderRadius: 18,
              boxShadow: '0 16px 40px rgba(0,0,0,.10)'
            }} data-id="element-189">
                  <img src={img.src} alt="" loading="lazy" className="w-full block transition-transform duration-500 ease-in-out hover:scale-105" style={{
                aspectRatio: '4/5',
                objectFit: 'cover',
                transform: 'scale(1.02)'
              }} data-id="element-190" />
                </div>)}
            </div>
          </div>

          {/* Right fade */}
          <div className="absolute top-0 bottom-0 right-0 z-10 pointer-events-none" style={{
          width: 70,
          background: 'linear-gradient(270deg, rgba(248,248,250,1), rgba(248,248,250,0))'
        }} data-id="element-191" />
        </div>
      </div>
    </section>;
}